import React, { Component } from "react";
import cx from "classnames";
import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

import "./ReactivateCTA.css";
import { showReactivatePopUpOrPage } from "../../../../utils/abTestUtils";

class ReactivateCTA extends Component {

  showPopupContent = () => {
    // Wordpress popup integration hack
    // This should not carry over once we move the popup to React
    const popup = document.querySelector(
      ".pum-content.popmake-content .not-for-expired"
    );
    if (popup) {
      popup.classList.remove("not-for-expired");
    }
  };

  render() {
    const {
      title,
      desc,
      ctaLabel,
      onClick,
      isMobile,
      iconClass,
      baseClass,
      showGrowthReactivatePopUp
    } = this.props;

    const styles = cx({
      [baseClass]: !!baseClass,
      mobile: isMobile,
      "ta-center": true,
      "no-items-cta": true,
      "mar-a": true
    });

    const iconStyle = cx({
      [iconClass]: !!iconClass,
      fal: true,
      "fa-shopping-bag": !iconClass,
      "add-ons-closed-i": true
    });

    return (
      <div className={styles}>
        <i className={iconStyle} />
        <h3 className="ff-ns">{title}</h3>
        <p className="description-text">{desc}</p>

        <Button
          className="case-caps"
          id={`${this.props.baseClass}-reactivate-cta`}
          type={buttonTypes.CALL_TO_ACTION}
          action={actionTypes.CALL_TO_ACTION.value}
          label={ctaLabel}
          onClick={e => {
            onClick(e);
            showReactivatePopUpOrPage(showGrowthReactivatePopUp);
          }}
          style={isMobile ? { width: "100%" } : {}}
        />
        <br />
      </div>
    );
  }
}

export default ReactivateCTA;



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/ReactivateCTA/ReactivateCTA.js